import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  wrapper: {
    maxWidth: 929,
    margin: '0 auto',
    display: 'flex',
    marginTop: 91,
    gap: 73,
    alignItems: 'center',
    padding: '0 16px',
    [forPhoneOnly]: {
      margin: 0,
      flexDirection: 'column',
    },
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    width: 281,
    [forPhoneOnly]: {
      display: 'none',
    },
  },
  mobileImage: {
    width: 160,
    margin: '0 auto',
    [forTabletPortraitUp]: {
      display: 'none',
    },
  },
  title: {
    ...typography['Lato H4 Bold'],
    [forPhoneOnly]: {
      display: 'none',
    },
  },
  description: {
    ...typography['Lato H5'],
    marginTop: 24,
    marginBottom: 40,
    [forPhoneOnly]: {
      marginTop: 0,
      marginBottom: 32,
      ...typography['Lato Body 1'],
    },
  },
  form: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    boxSizing: 'border-box',
    maxWidth: 434,
    [forPhoneOnly]: {
      alignItems: 'normal',
      paddingTop: 32,
    },
  },
  phoneInputContainer: {
    width: '100%',
    background: theme.palette.common.white,
    marginBottom: 8,
    '& .phoneInput': {
      paddingLeft: 12,
      borderBottom: `1px solid ${theme.palette.grey[800]}`,

      '& input': {
        borderBottom: 0,
      },
    },
  },
  phoneInputFocused: {
    borderBottom: `2px solid ${theme.palette.primary[800]}`,
  },
  mainCta: {
    marginBottom: 16,
  },
}))
